module.exports = __webpack_public_path__ + "img/metasalute-logo-no-bg.a984531c.png";